import * as React from "react";

import { setCanvasInteractionMode } from "@v1/components/canvas/canvas-reducer";
import { warningToast } from "@v1/components/designSystem/alert/Toast";
import { selectIsTextDynamicData } from "@v1/reducers/core-reducer";
import { useEditorDispatch, useEditorStore } from "@v1/store/store";

export const useEnableNonDynamicTextEditing = () => {
  const store = useEditorStore();
  const dispatch = useEditorDispatch();

  return React.useCallback(() => {
    const isTextDynamicData = selectIsTextDynamicData(store.getState());
    if (isTextDynamicData) {
      warningToast(
        "Can't edit dynamic data",
        "This component cannot be edited since it contains dynamic data. Remove dynamic data to edit.",
      );
      return;
    }

    dispatch(setCanvasInteractionMode("content-editing"));
  }, [dispatch, store]);
};
